import { Injectable } from '@angular/core';
import {
  DataRouteParamPersonId,
  DataPersonEntityId,
  DataPersonEntity,
  DataRouteParamModuleIndex,
} from '@edgvr-front/data/domain';
import {
  createEffect,
  Actions,
  ofType,
  EffectNotification,
} from '@ngrx/effects';
import { getSelectors } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  distinctUntilChanged,
  exhaustMap,
  filter,
  map,
  mergeMap,
  switchMap,
  takeUntil,
} from 'rxjs/operators';
import { DataPersonModulesListPageActions } from '../actions';
import { DataService } from '../services';
import { DataPersonGetRequestDTO } from '../dto';

const { selectRouteParams } = getSelectors();

@Injectable()
export class DataPersonModulesListPageEffects {
  dataModuleGet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataPersonModulesListPageActions.dataPersonGet),
      switchMap((_) =>
        this.dataService
          .dataPersonGet(new DataPersonGetRequestDTO({ id: _.id }))
          .pipe(
            mergeMap((_) => [
              DataPersonModulesListPageActions.dataPersonGetSuccess({
                dataPerson: DataPersonEntity.factory(_.data.dataPerson),
              }),
            ])
          )
      )
    )
  );

  selectedPersonSet$ = createEffect(() =>
    this.store.select(selectRouteParams).pipe(
      map((_) => Number(_[DataRouteParamPersonId]) as DataPersonEntityId),
      distinctUntilChanged(),
      filter((_) => Number.isSafeInteger(_)),
      mergeMap((_) => [
        DataPersonModulesListPageActions.selectedDataPersonSet({
          id: _,
        }),
        DataPersonModulesListPageActions.dataPersonGet({
          id: _,
        }),
      ])
    )
  );

  selectedPersonModuleSet$ = createEffect(() =>
    this.store.select(selectRouteParams).pipe(
      map((_) => Number(_[DataRouteParamModuleIndex])),
      distinctUntilChanged(),
      filter((_) => Number.isSafeInteger(_)),
      mergeMap((_) => [
        DataPersonModulesListPageActions.selectedDataPersonModuleSet({
          index: _,
        }),
      ])
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly dataService: DataService
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>) {
    return this.actions$.pipe(
      ofType(DataPersonModulesListPageActions.init),
      exhaustMap(() =>
        resolvedEffects$.pipe(
          takeUntil(
            this.actions$.pipe(ofType(DataPersonModulesListPageActions.destroy))
          )
        )
      )
    );
  }
}
